import { getDependencies, createDependenceCompound, deleteCompound } from "../../indexDB/dependencies";
import { getAllQuestion } from "../../indexDB/logic";

/**
 * Obtiene las dependencias simples ó standard
 * @returns { Object } - Devuelve un objeto con todas las dependencias simples ó standard
 */
const getStandard = async () => {
  try {
    const result = await getDependencies();
    const { simple } = result;
    return simple;
  } catch (error) {
    console.log("Error: getCompount: ", error);
  }
};
/**
 * Busca las dependencias de una pregunta
 * @param {string} nameDad - Id de la pregunta padre (P_X)
 * @returns { Pbject } - Devuelve un objeto con las preguntas vinculadas a la dependencia.
 */
const dataStandard = async nameDad => {
  try {
    const result = await getStandard();
    const objectStandard = result[nameDad];
    return objectStandard;
  } catch (error) {
    console.log("Error: dataCompound: ", dataCompound);
  }
};
/**
 * Verifica la propiedad answer ó answer para extraer las respuestas y validar su contenido que no sea  nulo ó undefined.
 * @param { Object } dataStandard - Objeto que contiene las dependencias de una pregunta.
 * @returns { Array } - Un array con las dependnecias.
 */
const formatAnswers = async dataStandard => {
  let listStandard = [];
  for (var i in dataStandard) {
    let data = null;

    if (dataStandard[i].hasOwnProperty("answer")) data = await answer(dataStandard, i);
    else data = await answers(dataStandard, i);
    data.children = data.children.filter(x => x !== undefined && x !== null );
    listStandard.push(data);
  }

  return listStandard;
};
/**
 * Obtiene la respuesta y el conjunto de preguntas asociadas a la depedndencia de la respuesta.
 * @param { Object } dataStandard - Objeto que contiene las dependencias de una pregunta donde su propiedad es answer.
 * @param {*} i - Nombre unico de la pregunta vinculada
 * @returns { Object }
 */
const answer = async (dataStandard, i) => {
  let answer = dataStandard[i].answer;
  let children = [];
  for (var j in dataStandard) {
    let _answer = dataStandard[j].answer;
    if (_answer === answer) {
      const question = await getQuestion(j);
      children.push(question);
      delete dataStandard[j];
    }
  }
  return { answer, children };
};

/**
 * Obtiene la respuesta y el conjunto de preguntas asociadas a la depedndencia de la respuesta.
 * @param {*} dataStandard - Objeto que contiene las dependencias de una pregunta donde su propiedad es answers.
 * @param {*} i - Nombre unico de la pregunta vinculada
 * @returns { Object }
 */
const answers = async (dataStandard, i) => {
  let answer = JSON.stringify(dataStandard[i].answers);
  const answers = dataStandard[i].answers;
  let children = [];

  for (var j in dataStandard) {
    let _answer = JSON.stringify(dataStandard[j].answers);
    if (_answer === answer) {
      const question = await getQuestion(j);
      children.push(question);
      delete dataStandard[j];
    }
  }
  return { answer: answers, children };
};

/**
 * Obtiene la estructura de una pregunta en base al nombre de la pregunta a buscar (P_X)
 * @param {string} nameQustion
 * @returns
 */
const getQuestion = async nameQustion => {
  const _questions = await getAllQuestion();
  return _questions.find(question => question.name === nameQustion);
};

export { dataStandard, formatAnswers };
